import React, { Component } from 'react';

class PDFViewer extends Component {
  constructor(props) {
    super(props);
    this.viewerRef = React.createRef();
    this.backend = new props.backend();
  }

  componentDidMount() {
    const { src } = this.props;
    const element = this.viewerRef.current;

    this.backend.init(src, element);
  }

  rotate = direction => {
    // check to make sure the backend has this function implemented
    if (this.backend.rotate) {
      this.backend.rotate(direction);
    }
  };

  render() {
    return (
      <div
        ref={this.viewerRef}
        id="viewer"
        style={{ width: '100%', height: '100%' }}
      ></div>
    );
  }
}

export default PDFViewer;
